import React from 'react'
import PropTypes from 'prop-types'

export default class CanvasUrl extends React.Component {
  static propTypes = {
    canvasUrl: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  }

  render() {
    return (
      <div className="maxw-600px mx-auto text-center">
        <h4>Canvas URL</h4>
        <p>Enter your Canvas URL so we know where to connect your course.</p>
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">https://</span>
          </div>
          <input
            className="form-control form-control-lg"
            placeholder="<your-school>.instructure.com"
            value={this.props.canvasUrl}
            onChange={event => this.props.onChange(event.target.value)}
          />
          <div className="input-group-append">
            <button
              disabled={!this.props.canvasUrl || this.props.submitting}
              className="btn btn-success"
              type="button"
              onClick={() => this.props.onSubmit(this.props.canvasUrl)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    )
  }
}
